import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Container from 'reactstrap/lib/Container';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { Breadcrumbs } from 'site-modules/shared/components/breadcrumbs/breadcrumbs';
import { bgFlag } from 'client/images/inline-svgs/ads/type-v2-icons-svgs';
import { getIcon } from 'site-modules/shared/utils/upper-funnel/get-svg-icon';
import { TYPE_SINGULAR_LOWERCASE_EXCEPTIONS } from 'site-modules/shared/utils/upper-funnel/type-mapping';
import { HERO_BG_PATHS } from './constants';

import './hero-content.scss';

const DESKTOP_BG_STYLE = {
  aspectRatio: '1200/318',
  maxHeight: '400px',
  minWidth: '100%',
  backgroundImage: `url(${HERO_BG_PATHS.lg})`,
  backgroundSize: 'cover',
};
const MOBILE_BG_STYLE = {
  aspectRatio: '390/492',
  backgroundImage: `url(${HERO_BG_PATHS.sm})`,
  backgroundSize: 'cover',
};

export function HeroContent({
  breadcrumbsData = null,
  isMobile = false,
  title = null,
  type = null,
  subtypeTitle = null,
}) {
  const typeDisplayCopy = type.replace(/suv/g, 'SUV');
  const typeCopySingularLowercase = TYPE_SINGULAR_LOWERCASE_EXCEPTIONS[type] || type;
  const isChildPage = !!subtypeTitle;
  const descriptionCopy = isChildPage
    ? `The Edmunds experts test drive ${subtypeTitle} contenders on our test track and in the real world. Our ratings assess performance, comfort, technology, utility, value and more. `
    : `The Edmunds experts test drive ${typeCopySingularLowercase} contenders on our test track and in the real world. Our ratings assess performance, comfort, technology, utility, value and more. `;
  const howWeRankCopy = isChildPage ? `How we rank ${subtypeTitle}s` : `How we rank ${typeCopySingularLowercase}s`;

  return (
    <header
      className={classnames('pos-r hero-content-wrapper', {
        'is-mobile': isMobile,
        'is-desktop': !isMobile,
      })}
      style={{ minHeight: '256px' }}
    >
      <div className="svg-wrapper">
        <div className="pos-a bottom-0 w-100 hidden-sm-down" style={DESKTOP_BG_STYLE} />
        <div className="pos-a bottom-0 w-100 hidden-sm-up" style={MOBILE_BG_STYLE} />
      </div>
      <Container>
        <Row data-tracking-parent="edm-entry-summary" className="text-shadow-contrast">
          <Col xs={12}>
            <Breadcrumbs
              className="px-0 m-0 pt-0_5 pb-0 disclaimer"
              olClassName={null}
              itemClassName="text-capitalize"
              data={breadcrumbsData}
            />
            <h1
              id="type-page-heading"
              className={classnames('text-white mt-0_5 mt-md-1_5 mb-0_75', {
                'size-36': !isMobile,
                'heading-2': isMobile,
              })}
            >
              {title}
            </h1>
          </Col>
          <Col xs={12} className="d-flex pb-3_5 pb-sm-0 mb-3_5 mb-sm-0">
            {!isChildPage && (
              <Fragment>
                {bgFlag}
                <div
                  className="flag-container me-1 pos-r d-flex flex-column align-items-center"
                  style={{ minWidth: '79px', height: '97px' }}
                  aria-hidden
                >
                  {getIcon(type)}
                  <span className="heading-7 text-center text-white d-block text-capitalize">{typeDisplayCopy}</span>
                </div>
              </Fragment>
            )}
            <div
              className="how-we-rank-wrapper size-16 fw-normal text-white pb-3_5 pb-sm-0 text-shadow-contrast"
              style={{ maxWidth: '560px' }}
            >
              {descriptionCopy}
              <a
                href="/car-reviews/features/how-we-test-cars-and-trucks.html"
                rel="noopener noreferrer"
                className="how-we-rank-link d-block"
              >
                {howWeRankCopy}
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </header>
  );
}

HeroContent.propTypes = {
  breadcrumbsData: PropTypes.arrayOf(PropTypes.shape({})),
  isMobile: PropTypes.bool,
  title: PropTypes.string,
  type: PropTypes.string,
  subtypeTitle: PropTypes.string,
};
